import { useMappedLoadedState } from '#src/app/shared/hooks/state';

import { useSession, useSessionAsync } from './session';
import type { AsyncState } from './shared/types';

// this should not be used by the app directly — it is only exposed for the benefit of the __mocks__ module
/** @knip-ignore */
export function useCookiePrefsSaved(): boolean {
	return useSession().cookiePrefsSaved;
}
export function useCookiePrefsSavedAsync(): AsyncState<boolean> {
	return useMappedLoadedState(useSessionAsync(), ({ value }) => ({ value: value.cookiePrefsSaved }));
}
